// extracted by mini-css-extract-plugin
export default {"container":"App_container__Auert","title":"App_title__rs3vh","card":"App_card__QCkwj"};